var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsFlexible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1620_6582",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1620_6582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00004 22V20.8173H5.16929C4.18595 19.6429 3.41833 18.35 2.86641 16.9384C2.31448 15.5269 2.03851 14.049 2.03851 12.5048C2.03851 10.9606 2.31448 9.48428 2.86641 8.07595C3.41833 6.66762 4.18595 5.37307 5.16929 4.1923H3.00004V3H7.54809V7.55768H6.36541V4.63845C5.39235 5.74485 4.62504 6.96504 4.06349 8.29903C3.50195 9.63299 3.22119 11.0349 3.22119 12.5048C3.22119 13.9747 3.50195 15.375 4.06349 16.7058C4.62504 18.0365 5.39235 19.2519 6.36541 20.3519V17.4519H7.54809V22H3.00004ZM16.8731 20.8153C16.5282 20.9358 16.1744 20.9919 15.8116 20.9836C15.4487 20.9753 15.1 20.8891 14.7654 20.725L8.33079 17.7326L8.70386 16.9346C8.83848 16.6782 9.02196 16.471 9.25431 16.3132C9.48668 16.1553 9.74486 16.0637 10.0288 16.0385L12.3058 15.8173L9.47696 8.07498C9.4026 7.87241 9.40961 7.6809 9.49799 7.50045C9.58637 7.32 9.73156 7.19244 9.93356 7.11778C10.1356 7.04309 10.3269 7.04988 10.5074 7.13813C10.688 7.22638 10.8157 7.37135 10.8904 7.57305L14.3884 17.1903L11.2634 17.4423L15.4039 19.3615C15.5462 19.4243 15.7016 19.4615 15.8702 19.4731C16.0388 19.4846 16.1974 19.4641 16.3462 19.4115L20.0308 18.0731C20.6179 17.8641 21.0426 17.4766 21.3048 16.9106C21.567 16.3445 21.5936 15.7679 21.3846 15.1807L20.0096 11.4307C19.9353 11.2282 19.9404 11.0365 20.025 10.8558C20.1096 10.675 20.2532 10.5474 20.4558 10.4731C20.6583 10.3987 20.85 10.4038 21.0308 10.4885C21.2115 10.5731 21.3391 10.7166 21.4134 10.9192L22.7884 14.6692C23.1525 15.6551 23.1189 16.613 22.6874 17.5429C22.256 18.4728 21.5461 19.1174 20.5577 19.4769L16.8731 20.8153ZM14.8635 14.373L13.5039 10.598C13.4295 10.3955 13.4365 10.204 13.5249 10.0235C13.6133 9.84305 13.7585 9.71549 13.9605 9.64083C14.1625 9.56616 14.3538 9.57295 14.5343 9.6612C14.7149 9.74943 14.8426 9.89441 14.9173 10.0961L16.2923 13.8461L14.8635 14.373ZM17.6116 13.3673L16.5866 10.5423C16.5122 10.3397 16.5192 10.1493 16.6076 9.97115C16.696 9.79297 16.8411 9.66701 17.0432 9.59328C17.2452 9.51954 17.4365 9.52498 17.6173 9.6096C17.7981 9.6942 17.9256 9.83778 18 10.0404L19.025 12.85L17.6116 13.3673Z",
    fill: "#49A0FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsFlexible);
export default __webpack_public_path__ + "static/media/is-flexible.b2df4da238b088b3fbef6401610b26fc.svg";
export { ForwardRef as ReactComponent };